import { PropsWithChildren } from "react";
import classNames from "classnames";
import { TextLink } from "../../../../shared/components/link/TextLink";
import {
  newsPost,
  newsPostContent,
  newsPostImage,
  newsPostLink,
} from "./styles.css";

export const NewsPost = ({
  className,
  children,
  slug = "/",
}: PropsWithChildren<{ className?: string; slug: string }>) => {
  return (
    <div className={classNames(newsPost, className)}>
      {children}
      <TextLink className={newsPostLink} to={slug}>
        Read more
      </TextLink>
    </div>
  );
};

export const NewsPostContent = ({ children }: PropsWithChildren) => {
  return <div className={newsPostContent}>{children}</div>;
};

export const NewsPostImage = ({ children }: PropsWithChildren) => {
  return <div className={newsPostImage}>{children}</div>;
};
